import React from 'react';
import { Typography } from 'antd';
import { EnvironmentOutlined } from '@ant-design/icons';
import ScrollReveal from '../../components/ScrollReveal';
import aboutHeroBg from '../../assets/images/about-life-meeting.png';
import cultureIcon01 from '../../assets/images/about/cut_01_compressed.webp';
import cultureIcon02 from '../../assets/images/about/cut_02_compressed.png';
import cultureIcon03 from '../../assets/images/about/cut_03_compressed.webp';
import lifeImg01 from '../../assets/images/about-life-meeting.png';
import lifeImg02 from '../../assets/images/about-life-office.png';
import lifeImg03 from '../../assets/images/about-life-warehouse.png';
import aboutMapBg from '../../assets/images/about/cut_04_compressed.webp';

const { Title, Paragraph } = Typography;

const cultures = [
  {
    icon: cultureIcon01,
    eyebrow: 'MISSION',
    title: '公司使命',
    desc: '以科技之力赋能企业',
  },
  {
    icon: cultureIcon02,
    eyebrow: 'VISION',
    title: '品牌愿景',
    desc: '始终走在科技和应用结合的前沿',
  },
  {
    icon: cultureIcon03,
    eyebrow: 'VALUES',
    title: '价值观',
    desc: '专注客户发展，关注员工成长',
  },
];

const About = () => {
  return (
    <div className="page-about">
      {/* Hero */}
      <section
        className="about-hero"
        style={{ backgroundImage: `url(${aboutHeroBg})` }}
      >
        <div className="about-hero-inner">
          <Title level={1} className="about-hero-title">
            关于我们
          </Title>
        </div>
      </section>

      {/* 公司简介 */}
      <section className="about-intro-section">
        <div className="about-intro-inner">
          <ScrollReveal>
            <div className="about-section-head">
              <Title level={2} className="about-section-title">
                公司简介
              </Title>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={150}>
            <div className="about-intro-content">
              <Paragraph className="about-intro-text">
              广州赤兴科技有限公司(下称赤兴科技)以时代科技发展为契机，紧跟时代浪潮，由众多长期在企业管理软件赛道的专家共同发起成立，致力于通过技术和企业管理软件的结合，真正打造一款符合中小微企业应用场景，能够好用，便宜用的新一代ERP产品。
              </Paragraph>
              <Paragraph className="about-intro-text">
              赤兴科技核心团队拥有多年大厂研发实战经验，产研骨干均毕业于清华、中大、等国内顶尖高校；团队多数成员拥有十年以上国内大厂及行业从业经历，深知中小微企业财税管理痛点与真实经营需求。公司现已自主申请，多项软件著作权及发明专利，具备完整自研技术壁垒。
              </Paragraph>
              <Paragraph className="about-intro-text">
              赤兴科技坚持以AI技术驱动，结合客户实际应用场景需求，解决小微企业的业财税需求，真正做到解决客户真需求，开箱即用，轻松交互，数据驱动，AI协助，有需即满足，千人千面的新一代ERP产品
              </Paragraph>
            </div>
          </ScrollReveal>
        </div>
      </section>

      {/* 企业文化 */}
      <section className="about-culture-section">
        <div className="about-culture-inner">
          <ScrollReveal>
            <div className="about-section-head">
              <Title level={2} className="about-section-title">
                企业文化
              </Title>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={150} className="about-culture-grid">
            {cultures.map((item) => (
              <article key={item.title} className="about-culture-card">
                <div className="about-culture-icon">
                  <img src={item.icon} alt={item.title} loading="lazy" decoding="async" />
                </div>
                <span className="about-culture-eyebrow">{item.eyebrow}</span>
                <h3 className="about-culture-title">{item.title}</h3>
                <p className="about-culture-desc">{item.desc}</p>
              </article>
            ))}
          </ScrollReveal>
        </div>
      </section>

      {/* 工作生活 */}
      <section className="about-life-section">
        <div className="about-life-inner">
          <ScrollReveal>
            <div className="about-section-head">
              <Title level={2} className="about-section-title">
                工作生活
              </Title>
            </div>
          </ScrollReveal>

          <ScrollReveal delay={150} className="about-life-grid">
            <div className="about-life-item">
              <img src={lifeImg01} alt="会议交流" loading="lazy" decoding="async" />
            </div>
            <div className="about-life-item">
              <img src={lifeImg02} alt="办公环境" loading="lazy" decoding="async" />
            </div>
            <div className="about-life-item">
              <img src={lifeImg03} alt="仓储物流" loading="lazy" decoding="async" />
            </div>
          </ScrollReveal>
        </div>
      </section>


    </div>
  );
};

export default About;